<template>
  <v-container fluid grid-list-md>
    <AppTitleBar>
      <template slot="title">{{ $t('title') }}</template>
      <template slot="actions">
        <v-tooltip top transition="fade-transition">
          <template v-slot:activator="{ on }">
            <v-btn icon small @click="create" v-on="on" v-if="multiOrg">
              <v-icon small v-text="$vuetify.icons.values.add" />
            </v-btn>
          </template>
          <span>{{ $t('new') }}</span>
        </v-tooltip>
      </template>
    </AppTitleBar>
    <v-row no-gutters justify="end">
      <v-col cols="12" sm="6" md="4" lg="3">
        <SingleSearchFilter :context="context" :fields="searchFields" />
      </v-col>
    </v-row>
    <v-col cols="12" v-if="loading">
      <v-loading />
    </v-col>
    <v-col cols="12" v-else>
      <organization-list
        v-if="hasOrganizations"
        :organizations="organizations"
        :viewItem="viewItem"
        :editItem="editItem"
      />
      <no-organization v-else />
    </v-col>
    <router-view></router-view>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import { AppTitleBar, SingleSearchFilter, VLoading } from '@argon/app/components'
import { OrganizationList, NoOrganization } from '../components'
import { NAMESPACE } from '../store'
import organizationPerimeter from '../perimeters'

export default {
  name: 'Organizations',
  components: {
    AppTitleBar,
    VLoading,
    OrganizationList,
    NoOrganization,
    SingleSearchFilter
  },
  mixins: [Datatable],
  perimeters: [organizationPerimeter],
  data: () => ({
    loading: true,
    searchFields: [{ label: 'display', type: 'text' }],
    context: NAMESPACE
  }),
  computed: {
    ...mapState(NAMESPACE, ['organizations', 'multiOrg']),
    hasOrganizations() {
      return this.organizations.length > 0
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['listOrganizations', 'setFilters']),
    viewItem(item) {
      this.$router.push({
        name: 'orgOverview',
        params: { orgRef: item.refname }
      })
    },
    editItem(item) {
      this.$router.push({
        name: 'organization',
        params: { orgRef: item.refname }
      })
    },
    create() {
      this.$router.push({ name: 'newOrganization' })
    },
    fetchData() {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.listOrganizations({ pager: this.pager })
          .then(resolve)
          .catch(reject)
          .finally(() => {
            this.loading = false
          })
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<i18n>
{
  "en": {
    "emptyDescription": "Creating an organization, you'll be able to collaborate with people.",
    "emptyLabel": "Create your first organization",
    "new": "New Organization",
    "title": "@:labels.organizations"
  },
  "fr": {
    "emptyDescription": "En créant une organisation, vous pourrez collaborer avec d'autres personnes.",
    "emptyLabel": "Créez votre première organisation",
    "new": "Nouvelle organisation",
    "title": "@:labels.organizations"
  }
}

</i18n>
